// CB:BEGIN demo-bids-shared
export interface DemoProjectBid {
  id: number;
  title: string; // short address
  addressFull: string; // full address with ZIP
  location: string;
  details: string;
  budget: string;
  bids: number;
  expires: string;
  datePosted: string;
  sqFt: number;
  material: string;
  defaultBid: number;
}

export function getDemoProjects(): DemoProjectBid[] {
  return [
    {
      id: 1,
      title: '2456 Maple Ave, Nashville, TN',
      addressFull: '2456 Maple Ave, Nashville, TN 37205',
      location: 'Emergency | Residential',
      details: 'Bids: 2 | Expires: 18 hours',
      budget: '$9,000 - $12,000',
      bids: 2,
      expires: '18 hours',
      datePosted: '2024-01-15',
      sqFt: 2400,
      material: 'Asphalt Shingles',
      defaultBid: 18500
    },
    {
      id: 2,
      title: '789 Pine St, Nashville, TN',
      addressFull: '789 Pine St, Nashville, TN 37209',
      location: '2 Weeks | Commercial',
      details: 'Bids: 1 | Expires: 12 hours',
      budget: '$6,000 - $8,000',
      bids: 1,
      expires: '12 hours',
      datePosted: '2024-01-16',
      sqFt: 1800,
      material: 'Metal',
      defaultBid: 4800
    },
    {
      id: 7,
      title: '1621 Crimson Hills Drive, St Peters MO',
      addressFull: '1621 Crimson Hills Drive, St Peters MO 63376',
      location: 'Residential',
      details: 'No bid yet | Ready for bid',
      budget: '$15,000 - $20,000',
      bids: 0,
      expires: '5 days',
      datePosted: '2024-01-20',
      sqFt: 2482,
      material: 'Asphalt Shingles',
      defaultBid: 18500
    }
  ];
}

// CB:BEGIN fix-tdz-selected-key
// Inline constant string directly in functions to completely avoid TDZ issues
// CB:END fix-tdz-selected-key

export function setSelectedDemoProject(project: DemoProjectBid): void {
  try { localStorage.setItem('cb_selected_demo_project', JSON.stringify(project)); } catch {}
}

export function getSelectedDemoProject(): DemoProjectBid | null {
  try {
    const raw = localStorage.getItem('cb_selected_demo_project');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
// CB:END demo-bids-shared


